/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import toast from 'react-hot-toast'
import imagePlaceholder from '../../../assets/svg/image_placeholder.svg'
import { ReactComponent as IconGreyRemoveBrand } from '../../../assets/svg/icon-grey-remove.svg'
import { ReactComponent as IconClose } from '../../../assets/svg/close-icon.svg'
import config from '../../../config'
import { useUser } from '../../../hooks/useUser'
import axiosInstant from '../../../api'
import { useWorkspaceBrandId } from '../../../hooks/useWorkspaceBrandId';
import { BriefBrandAssetsFields } from '../../../components/Brief/BriefBrandAssetsFields'
import { BRIEF_BRAND_ASSET_KEYS } from '../../../components/Brief/constants'
import { brandBriefAssetUpload } from '../../../api/endpoints'

const SignupSchema = Yup.object().shape({
  name: Yup.string(),
})

export default function BrandSettings(props) {
  const { user, brand } = useUser()
  const [logo, setLogo] = useState(null)
  const [brand_guidelines, setBrandGuidelines] = useState(null)
  const [logoUrl, setLogoUrl] = useState(null)
  const [brandGuidelinesUrl, seBrandGuidelinesUrl] = useState(null)
  const [brandData, setBrandData] = useState([])
  const [teamMembers, setTeamMembers] = useState([])
  // const [teamInput, setTeamInput] = useState('')
  // const [productInput, setProductInput] = useState('')
  const [products, setProducts] = useState([])
  // const [showSearchedProducts, setShowSearchedProducts] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  // const [searchedProducts, setSearchedProducts] = useState([])
  // const [loaderDropdown, setLoaderDropdown] = useState(false)
  // const dropdownRef = useRef(null)

  // const navigate = useNavigate()

  const workspaceBrandId = useWorkspaceBrandId()
  const id = workspaceBrandId || (brand ? brand[0].id : 0)

  const updateTeamMembers = (e) => {
    axiosInstant
      .get(`${config.API_URL}/brands/${id}/team`)
      .then((response) => {
        setTeamMembers(response.data.rows)
      })
      .catch((error) => {})
  }

  const updateProducts = (e) => {
    axiosInstant
      .get(`${config.API_URL}/brands/${id}/products`)
      .then((response) => {
        const tmpProductsName = [...products]
        const tmpProductsIds = [...selectedProducts]
        response.data.rows.map((item, i) => {
          tmpProductsName.push(item.title)
          tmpProductsIds.push(item.desireid)
          return item
        })

        setProducts(response.data.rows)
        setSelectedProducts(tmpProductsIds)
      })
      .catch((error) => {})
  }

  useEffect(() => {
    // get pros
    axiosInstant.get(`${config.API_URL}/brands/${id}`).then((response) => {
      setBrandData(response.data)
      if (response.data && response.data.logo && response.data.logo.length > 0) {
        setLogoUrl(response.data.logo)
      }
      if (response.data && response.data.brand_guidelines && response.data.brand_guidelines.length > 0) {
        seBrandGuidelinesUrl(response.data.brand_guidelines)
      }
    })

    // get products
    axiosInstant.get(`${config.API_URL}/brands/${id}/desires`).then((response) => {
      console.log(response.data)
    })

    updateTeamMembers()
    updateProducts()
  }, [])

  // Transform Image to Base 64
  const getBase64 = (file, inputName) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (inputName === 'logo') {
        setLogo(reader.result)
      } else {
        setBrandGuidelines(reader.result)
      }
    }
    reader.onerror = function (error) {
      console.log('Error: ', error)
    }
  }

  // Handle Logo Change
  const handleLogoChange = (e) => {
    e.preventDefault()
    setLogoUrl(URL.createObjectURL(e.target.files[0]))
    getBase64(e.target.files[0], 'logo')
  }
  const removeLogo = (e) => {
    e.preventDefault()
    setLogoUrl(null)
    setLogo(null)
  }

  // Handle BrandGuideline Change
  // const handleBrandGuidelinesChange = (e) => {
  //     e.preventDefault()
  //     seBrandGuidelinesUrl(URL.createObjectURL(e.target.files[0]))
  //     getBase64(e.target.files[0], 'brand_guidelines')
  // }
  // const removeBrandGuidelines = (e) => {
  //     e.preventDefault()
  //     seBrandGuidelinesUrl(null)
  //     setBrandGuidelines(null)
  // }

  // Add and Remove Team Member Save
  // const handleTeamChange = (e) => {
  //     setTeamInput(e.target.value)
  // }
  // const handleAddTeamMember = () => {
  //     const team = {}

  //     // check if the email is valid
  //     const re =
  //         /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  //     // if email is valid then add to team
  //     if (re.test(teamInput)) {
  //         team.user_emails = [teamInput]
  //         axiosInstant.post(`${config.API_URL}/brands/${id}/team`, team).then((response) => {
  //             if (response.data.updated.length === 0) {
  //                 toast.error(response.data.errors)
  //             } else {
  //                 setTeamInput('')
  //                 toast.success(`${teamInput} has been added to your member list`)
  //                 updateTeamMembers()
  //             }
  //         })
  //     } else {
  //         setTeamInput('')
  //         toast.error('Your email is not a valid one')
  //     }
  // }
  // const handleRemoveMember = (memberId) => {
  //     axiosInstant.delete(`${config.API_URL}/brands/${id}/team/${memberId}`).then((response) => {
  //         toast.success('Team member has been deleted.')
  //         updateTeamMembers()
  //     })
  // }

  // Products
  // const handleshowSearchedProducts = (e) => {
  //     e.preventDefault()
  //     setShowSearchedProducts(true)
  //     setProductInput('')
  //     setLoaderDropdown(true)
  // }

  // const handleProductChange = (e) => {
  //     setLoaderDropdown(true)
  //     setProductInput(e.target.value)
  //     axiosInstant
  //         .get(`https://api.prod.thedesirecompany.com/api/v1/search?q=${e.target.value}&type=desires&from=0&size=10`)
  //         .then((response) => {
  //             setSearchedProducts(response.data.hits.hits)
  //             setShowSearchedProducts(true)
  //             setLoaderDropdown(false)
  //         })
  //         .catch((error) => {})
  // }

  // const handleAddSearchedProduct = (product) => {
  //     const desireIds = {
  //         desire_ids: product._source.desireid,
  //     }

  //     axiosInstant
  //         .post(`${config.API_URL}/brands/${id}/products`, desireIds)
  //         .then((response) => {
  //             toast.success('Product Added')
  //             updateProducts()
  //             setShowSearchedProducts(false)
  //             setProductInput('')
  //         })
  //         .catch((error) => {
  //             toast.error('An error has been encountered.Please try again')
  //         })
  // }

  // const handleRemoveProduct = (index, product_id) => {
  //     axiosInstant.delete(`${config.API_URL}/brands/${id}/products/${product_id}`).then((response) => {
  //         toast.success('Product deleted.')
  //         updateProducts()
  //     })
  // }

  // Handle General Form Changes
  const handleSaveChanges = (values) => {
    const params = {}

    if (logo) {
      params.logo = logo
    }

    if (brand_guidelines) {
      params.brand_guidelines = brand_guidelines
    }
    if (values.name) {
      params.name = values.name
    }
    // TDC-1722 brief assets: every new brief on this brand starts from these.
    BRIEF_BRAND_ASSET_KEYS.forEach((key) => {
      params[key] = values[key] || ''
    })

    axiosInstant
      .patch(`${config.API_URL}/brands/${id}`, params)
      .then((response) => {
        toast.success('Brand Informations Saved')
      })
      .catch((error) => {
        const data = error && error.response && error.response.data
        const code = typeof data === 'string' ? data : data && data.error
        if (code === 'WebsiteDomainNotAllowed') {
          toast.error("Use your brand's own website, not a retailer, marketplace or social page.")
        } else if (code === 'InvalidWebsite') {
          toast.error("Enter your brand's website, e.g. yourbrand.com")
        } else {
          toast.error('Brand edit error')
        }
      })

    //
    // Products settings
    axiosInstant.post(`${config.API_URL}/brands/${id}/desires`, products).then((response) => {
      console.log(response)
    })
  }

  return (
    <Formik
      initialValues={{
        brand_guidelines: '',
        categories: [],
        cover_image: '',
        description: '',
        logo: '',
        name: brandData.name && brandData.name.length > 0 ? brandData.name : '',
        site_url: '',
        marketing_calendar: '',
        products: [],
        ...Object.fromEntries(BRIEF_BRAND_ASSET_KEYS.map((key) => [key, brandData[key] || ''])),
      }}
      validationSchema={SignupSchema}
      enableReinitialize
      onSubmit={(values) => {
        handleSaveChanges(values)
      }}
    >
      {({ errors, touched }) => (
        <Form className="w-full">
          <h3 className="text-text-1 text-3xl font-bold uppercase font-[CircularStd]">Brand</h3>
          <span className="text-base font-bold text-left block mb-4 mt-3">Brand Name*</span>
          <Field placeholder="Brand Name" name="name" type="text" className={`appearance-none text-sm border rounded w-full  p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-2 ${errors.name && touched.name ? 'border-error' : 'border-border-token'}`} />
          {errors.name && touched.name ? <div className="text-left text-error text-xs font-bold mt-1 pl-5">{errors.name}</div> : null}

          <div>
            <span className="text-base font-bold text-left block mb-4 mt-3">Logo*</span>
            <div className="border-2 border-border-token my-5 flex justify-start rounded-xl relative">
              <input onChange={(e) => handleLogoChange(e)} name="logo" id="logo" type="file" className={`opacity-0  absolute z-10 top-0 left-0 right-0 bottom-0 appearance-none text-sm border rounded w-full mb-0 p-4 rounded-xl text-text-1 leading-tight focus:outline-none focus:shadow-outline mb-3 ${errors.logo && touched.logo ? 'border-error' : 'border-border-token'}`} />
              {errors.logo && touched.logo ? <div className="text-left text-error text-xs font-bold mt-1 pl-5">{errors.logo}</div> : null}
                {!logoUrl ? 
                  <div className="w-[25%] bg-surface-2 max-w-[140px] h-[100px] flex items-center justify-center rounded-bl-xl rounded-tl-xl">
                    <img src={imagePlaceholder} alt="place-holder" /> 
                  </div>
                : 
                  <div className="bg-surface-2 max-w-[140px] h-[100px] flex items-center justify-center rounded-bl-xl rounded-tl-xl">
                    <img className="rounded-bl-xl rounded-tl-xl w-full h-full" src={logoUrl} alt="preview logo" />
                  </div>
                }
              <div className="w-[75%] text-base text-center flex items-center justify-center py-4">
                {!logo && (
                  <div>
                    Drag and drop picture or &nbsp; <u className="font-bold"> Click here to upload</u>
                  </div>
                )}

                {logo && <div className="relative z-10">You have one file. </div>}
                {logo && <IconGreyRemoveBrand className="relative z-10 ml-3" onClick={(e) => removeLogo(e)} />}
              </div>
            </div>
          </div>

          <div className="mt-8">
            <BriefBrandAssetsFields
              heading="Brief Assets"
              uploadUrlFor={(kind) => (id ? brandBriefAssetUpload(id, kind) : undefined)}
            />
          </div>

          <button className="bg-accent text-base text-white mx-auto mt-6 py-3 px-5 lg:px-10 block rounded-xl focus:outline-none focus:shadow-outline" type="submit">
            Save changes
          </button>
        </Form>
      )}
    </Formik>
  )
}
